module.exports = __webpack_public_path__ + "static/media/splash2_1x.aab61b29.jpg";